import React from 'react';
import AnalyticsCard from '../../analytics-card/AnalyticsCard';
import './accepted-cookies-card.scss';
import { withAnalyticsAppContext } from '../../../context/analytics-app-context';

function AcceptedCookiesCard({ appContext }) {
    const { loading } = appContext;
    const {
        analyticsCardTitle,
        visitorsThatAcceptedCookies
    } = appContext.analyticsData || {};
    return (
        <div className='analytics-grid-accepted-cookies grid-item'>
            <AnalyticsCard
                isLoading={loading}
                title={'Accepted All Cookies'}
                content={`${visitorsThatAcceptedCookies || 0}`}
                chipValue={analyticsCardTitle || ''}
            ></AnalyticsCard>
        </div>
    );
}

export default withAnalyticsAppContext(AcceptedCookiesCard);
